export default "__VITE_ASSET__R16oBNP8__"